import { UserMailComponent } from './users/user-mail/user-mail.component';
import { UserDialogComponent } from './users/user-dialog/user-dialog.component';
import { NgModule, Component } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { SharedModule } from '../shared/shared.module'; 
import { MenuComponent } from './components/menu/menu.component';
import { UserMenuComponent } from './components/user-menu/user-menu.component';
import { FullScreenComponent } from './components/fullscreen/fullscreen.component'; 
import { MessagesComponent } from './components/messages/messages.component';
import { BreadcrumbComponent } from './components/breadcrumb/breadcrumb.component'; 
import { SuperAdminComponent } from './super-admin.component';
import { AuthentificationGuard } from '../services/guards/authentification.guard';
import { PermissionUserGuardGuard } from '../services/guards/permission-user-guard.guard';
import { LitigesComponent } from './litiges/litiges.component';
import { SinistresComponent } from './sinistres/sinistres.component';
import { EtatsLieuxComponent } from './etats-lieux/etats-lieux.component';
import { DetailsComponent } from './sinistres/details/details.component';
import { ShowconstatComponent } from '../compte-utilisateur/showconstat/showconstat.component';
import { NotificationUserAddComponent } from './components/notification-user-add/notification-user-add.component';
import { NgxSpinnerModule } from 'ngx-spinner';
import { NgImageSliderModule } from 'ng-image-slider';
import { NgxPaginationModule } from 'ngx-pagination';


export const routes = [ 
  { 
    path: '', 
    canActivate: [AuthentificationGuard],
    component: SuperAdminComponent, children: [
      { 
        path: '', 
        loadChildren: () => import('./dashboard/dashboard.module').then(m => m.DashboardModule),
        canActivate: [PermissionUserGuardGuard],
        data: {perms: [1]}
      }, 
  
      { 
        path: 'users', 
        loadChildren: () => import('./users/users.module').then(m => m.UsersModule),
        canActivate: [PermissionUserGuardGuard],
        data: { breadcrumb: 'Users', perms: [4]} 
      },

      { 
        path: 'assurance', 
        loadChildren: () => import('./assurance/assurance.module').then(m => m.AssuranceModule),
        canActivate: [PermissionUserGuardGuard],
        data: { breadcrumb: 'Calcul des frais d’assurance', perms: [6]}
      },

      { 
        path: 'locations', 
        loadChildren: () => import('./locations/locations.module').then(m => m.LocationsModule),
        canActivate: [PermissionUserGuardGuard],
        data: { perms: [2] }
      },

      { 
        path: 'payement', 
        loadChildren: () => import('./payement/payement.module').then(m => m.PayementModule),
        canActivate: [PermissionUserGuardGuard],
        data: { perms: [3] }
      },
      { 
        path: 'vehicules', 
        loadChildren: () => import('./vehicules/vehicules.module').then(m => m.VehiculesModule),
        canActivate: [PermissionUserGuardGuard],
        data: { breadcrumb: 'voiture', perms: [5]} 
      },
      { 
        path: 'litiges', 
        component:LitigesComponent,
        canActivate: [PermissionUserGuardGuard],
        data: { breadcrumb: 'Litiges', perms: [7]} 
      },
      { 
        path: 'sinistres', 
        component:SinistresComponent,
        canActivate: [PermissionUserGuardGuard],
        data: { breadcrumb: 'Sinistres', perms: [8]} 
      },
      { 
        path: 'constats', 
        component:EtatsLieuxComponent,
        canActivate: [PermissionUserGuardGuard],
        data: { breadcrumb: 'Etat des lieux', perms: [9]} 
      },
      { 
        path: 'voir-constat', 
        component:ShowconstatComponent,
        canActivate: [PermissionUserGuardGuard],
        data: { breadcrumb: 'Détails', perms: [9]} 
      },
      { path: 'details-sinistre', 
        component: DetailsComponent, 
        data: { breadcrumb: 'Détails', perms: [8]}
      },
      { 
        path: 'statistiques', 
        loadChildren: () => import('./statistiques/statistiques.module').then(m => m.StatistiqueModule),
        canActivate: [PermissionUserGuardGuard],
        data: { breadcrumb: 'statistique', perms: [5]} 
      },


    ]
  } 
];


@NgModule({
  declarations: [
    SuperAdminComponent,
    MenuComponent,
    UserMenuComponent,
    FullScreenComponent,
    MessagesComponent,
    BreadcrumbComponent,
    LitigesComponent,
    SinistresComponent,
    EtatsLieuxComponent,
    DetailsComponent,
    UserDialogComponent,
    UserMailComponent,
    NotificationUserAddComponent
  ],
  imports: [
    CommonModule,
    RouterModule.forChild(routes),
    SharedModule,
    NgxSpinnerModule,
    NgImageSliderModule,
    NgxPaginationModule
  ]
})
export class SuperAdminModule{ }